<script lang="ts" setup>
import { useAppBrand } from '@composables/tools/app-brand.hook'

import cobwebSvg from '@images/banners/upsell-halloween/cobweb.svg'
import cobwebSmartestmindsSvg from '@images/banners/upsell-halloween/cobweb-smartestminds.svg'
import cobwebMobileSvg from '@images/banners/upsell-halloween/cobweb-mobile.svg'
import cobwebMobileSmartestmindsSvg from '@images/banners/upsell-halloween/cobweb-mobile-smartestminds.svg'

defineOptions({
  name: 'BannerUpsellCobweb',
})

const TABLET_MEDIA = '(min-width: 740px)'

const { isSmartestMinds } = useAppBrand()

const cobweb = isSmartestMinds ? cobwebSmartestmindsSvg : cobwebSvg
const cobwebMobile = isSmartestMinds ? cobwebMobileSmartestmindsSvg : cobwebMobileSvg
</script>

<template>
  <picture class="banner-upsell-cobweb">
    <source
      :srcset="cobweb"
      :media="TABLET_MEDIA"
    >
    <img
      :src="cobwebMobile"
      class="banner-upsell-cobweb__image"
      alt="Cobweb corner decoration"
    >
  </picture>
</template>

<style scoped lang="scss" src="@scss/components/Atoms/UpsellBanner/BannerUpsellCobweb.scss" />
